import { action, computed, debug, NetbankingAPI, observable } from "aaa";
import { NetbankingAPIClient } from "network/APIClient";
import { CardAccountsStore } from "stores/CardAccountsStore";
import { CardStore } from "stores/CardStore";
import { ILinkageResponse } from "types/account";

export class LinkAccountStore {
    cardStore = new CardStore();
    cardAccountsStore = new CardAccountsStore();

    @observable isLoadingLink = false;
    response?: ILinkageResponse;

    @computed get isLoading(): boolean {
        return this.cardStore.isLoading || this.cardAccountsStore.isLoading;
    }

    @action async load(cardId: string) {
        await Promise.all([
            this.cardStore.loadCard(cardId),
            this.cardAccountsStore.load(cardId)
        ]);
    }

    @action async linkAccounts() {
        if (!this.cardStore.card ||
            !this.cardAccountsStore.linkedAccountsChanged) {
            return;
        }

        try {
            this.isLoadingLink = true;
            const target = NetbankingAPI.putAccoutsLinkage(
                this.cardStore.card.id,
                this.cardAccountsStore.newLinkedAccountIDs,
                this.cardAccountsStore.newUnlinkedAccountIDs);

            this.response = await NetbankingAPIClient.requestType(target);
            debug.log("### linkAccounts", this.response);
            this.isLoadingLink = false;
        } catch (error) {
            this.isLoadingLink = false;
            throw error;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/linkAccount/LinkAccountStore.tsx